import { type SugarPublishedTuitionRate } from '@app/types'

// Returns the row that governs scholarship-opt-in lock state for a program year,
// or null when that year has no row at all -- which means the year is still open
// (a program year with no record can never be locked).
//
// Lock state is per program year and current-row-authoritative: every row the API
// returns for a year reports that year's answer, computed server-side from the
// site's newest row for it. /history comes back ordered by effective date
// descending, so the first match is that year's newest row -- the same one the
// backend locks from. Rows within a year are expected to agree; taking the newest
// keeps us aligned with the server if they ever don't.
export const findScholarshipLockRow = (
  history: SugarPublishedTuitionRate[] | undefined,
  programYearId: string | null | undefined
): SugarPublishedTuitionRate | null => {
  if (!history || !programYearId) return null

  return history.find((row) => row.programYearId === programYearId) ?? null
}
